<div class="fondo-negro animated fadeIn" [ngClass]="_modalRegister.oculto" tabindex="-1" role="dialog">

    <div class="modal" style="display: block;" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="form-group m-b-0">

                        <h4 class="card-title text-blue">Lotus ERP.</h4>
                        <h6 class="card-subtitle text-info">Inscríbete y lleva tu empresa a otro nivel!</h6>
                    </div>
                    <button (click)="cerrarModal()" type="button" class="close pointer" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                    </button>
                </div>


                <div class="login-register ">
                    <div class="card-body">

                        <form #f="ngForm" ngNativeValidate (ngSubmit)="registrarUsuario(f)" class="form-horizontal " id="loginform" action="index.html">


                            <div class="form-group validate ">

                                <div class="input-group {{rucExiste==false?'has-success':'has-danger'}}">
                                    <div class="input-group-addon"><i class="  {{loadRuc==true?'fa fa-spin fa-spinner text-success':'mdi mdi-format-list-numbers'}} "></i></div>
                                    <input type="text" (change)="buscaRuc()" id="ruc" class="form-control  {{rucExiste==false?'form-control-success':'form-control-danger'}}" [(ngModel)]="usuario.ruc" required name="ruc" placeholder="RUC">


                                </div>
                            </div>

                            <div class="form-group">

                                <div class="input-group">
                                    <div class="input-group-addon"><i class="icon   icon-home"></i></div>
                                    <input type="text" class="form-control" [(ngModel)]="usuario.razonSocial" name="razonSocial" id="razonSocial" required placeholder="Razon social">
                                </div>
                            </div>

                            <div class="form-group">

                                <div class="input-group">
                                    <div class="input-group-addon"><i class="icon   icon-user"></i></div>
                                    <input type="text" class="form-control" [(ngModel)]="usuario.nombre" name="nombrecontacto" id="nombres" required placeholder="Nombre contacto">
                                </div>
                            </div>

                            <div class="form-group">

                                <div class="input-group">
                                    <div class="input-group-addon"><i class="icon icon-phone"></i></div>
                                    <input type="text" class="form-control" [(ngModel)]="usuario.telefono" name="telefono" id="phone" required placeholder="Ingrese Telefono de contacto">
                                </div>
                            </div>

                            <div class="form-group validate">

                                <div class="input-group {{emailExiste==false?'has-success':'has-danger'}}">
                                    <div class="input-group-addon"><i class=" {{loadEmail==true?'fa fa-spin fa-spinner text-success':' ti-email'}} "></i></div>
                                    <input type="email" (change)="buscaEmail()" class="form-control  {{emailExiste==false?'form-control-success':'form-control-danger'}}" [(ngModel)]="usuario.email" required name="email" id="email" placeholder="Enter email">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="checkbox checkbox-success">
                                    <input id="checkbox1" type="checkbox" [(ngModel)]="usuario.condiciones" name="condiciones">
                                    <label for="checkbox1"> Estoy de acuerdo con los  <a href="#">términos</a></label>
                                </div>
                            </div>

                            <div class="form-group text-center m-t-20">
                                <div class="col-xs-12">
                                    <button [disabled]="loadRegister" class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" type="submit" [disabled]="f.form.invalid">
                                            <span [hidden]="!loadRegister" ><i class="fa fa-spin fa-spinner"></i></span>{{textoRegistrar}}
                                        </button>
                                </div>
                            </div>
                            <br><br>
                            <div class="card-subtitle">

                                Al registrarte, aceptas nuestras <a href="#" target="_blank">Condiciones de uso</a> y <a href="#" target="_blank">Política de privacidad</a>.

                            </div>
                            <br><br>
                        </form>
                    </div>
                </div>



            </div>
        </div>
    </div>
</div>